module.exports = __webpack_public_path__ + "static/img/ml-indexbg.2e5ada1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ml-indexbg.jpg
// module id = Dqh6
// module chunks = 8